// extracted by mini-css-extract-plugin
module.exports = {"group":"SidebarGroup_group__RCVOh","groupName":"SidebarGroup_groupName__QP_SP","itemList":"SidebarGroup_itemList__dN3d8"};